export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    // Image click on listing page
    var siteUrl = window.location.pathname;

    $('.main-slider').slick({
      arrows: false,
      touchThreshold: 2500,
      speed: 200,
    });
    $('.main-slider-mobile').slick({
      arrows: false,
      touchThreshold: 2500,
      speed: 200,
    });

    function isSafari() {
      return navigator.vendor &&
        navigator.vendor.indexOf('Apple') > -1 &&
        navigator.userAgent &&
        !navigator.userAgent.match('CriOS');
    }

    if(isSafari() && $(window).width() < 1024) { //apply to safari and only if width is in mobile-ish range
      $('div.size.medium').addClass('safari');
      $('div.nav-click-receiver.medium').addClass('safari');
    }

    var hash = window.location.hash;
    if(hash!==""){
      popupSlider( parseInt(hash.substring(1)) );
    }

    function popupSlider(slideIndex) {
      $('.slider-overlay').addClass('show');
      $('#header').addClass('fixed-position');
      $('.slider-container').addClass('show');
      $('body').addClass('overflow-hidden');
      updateURL2(slideIndex);
      scrollToSlide(slideIndex);
    }

    function initImage(that){
      $(that).attr("src",$(that).data('src'));
      $(that).attr("srcset",$(that).data('srcset'));
      $(that).removeClass('lazyload');
      $(that).addClass('lazyloaded');
    }

    function initBgImage(that){
      if($(that).data('style')) {
        $(that).attr('style', $(that).data('style'));
      }

      $(that).find('.size').each(function() {
        if($(this).data('style')) {
          $(this).attr('style', $(this).data('style'));
        }
      });
    }

    function lasyLoadSlides(slider){
      // current slide
      slider.find('.slick-active').find('.lazyload').each(function(){
        initImage(this);
      });
      slider.find('.slick-active').each(function(){
        initBgImage(this);
      });

      // next slide
      slider.find('.slick-active').next().find('.lazyload').each(function(){
        initImage(this);
      });
      slider.find('.slick-active').next().each(function(){
        initBgImage(this);
      });

      // prev slide
      slider.find('.slick-active').prev().find('.lazyload').each(function(){
        initImage(this);
      });
      slider.find('.slick-active').prev().each(function(){
        initBgImage(this);
      });

    }

    function scrollToSlide(slideIndex) {
      var slider;
      if($(window).width()<768) {
        slider = $('.main-slider-mobile');
        $('#fullscreen').show();
      } else {
        slider = $('.main-slider');
      }
      slider.slick('slickGoTo', slideIndex);
      lasyLoadSlides(slider);
    }

    $('.merrick-portfolio-item img, .merrick-portfolio-item svg').on('click', function(){
      var slideIndex = $(this).data('slide-index');
      var mobileSlideIndex = $(this).data('mobileslide-index');
      if($(window).width()<768) {
        if($(this).closest('[data-video]').length) {
          $(this).closest('[data-video]').find('.embed-container__mobile').css({display: 'block'});
          $(this).closest('[data-video]').find('.embed-container__mobile iframe').attr('src', $(this).closest('[data-video]').find('.embed-container__mobile iframe').attr('src') + '&autoplay=1');
        } else { //below won't fire due to pointer events, but let's keep in place in case we change later
          popupSlider(mobileSlideIndex);
        }
      } else {
        popupSlider(slideIndex);
      }
    });

    // Back to home
    function hideSlider() {
      var $contactOverlay = $('#contact-overlay');
      var $contactContent = $('#contact-content');
      if($contactOverlay.hasClass('show')){
        $contactOverlay.removeClass('show');
        $contactContent.removeClass('show');
      }
      $('.slider-overlay').removeClass('show');
      $('#header').removeClass('fixed-position');
      $('.slider-container').removeClass('show');
      $('body').removeClass('overflow-hidden');

      window.history.pushState({"pageTitle":"Merrick d'Arcy-Irvine"},"", siteUrl);

      $('header').removeClass('light');
      $('.nav-container-mobile .nav-arrow-r').removeClass('light');
      $('.nav-container-mobile .nav-arrow-l').removeClass('light');
    }

    $('#home, #private-index').on('click', function(e){
      if( $('.slider-overlay').hasClass('show') ){
        e.preventDefault();
        hideSlider();
      }
    });

    $(document).keyup(function(e) {
        if (e.which === 27) { // esc
          hideSlider();
        }
    });


    $('.back-to-gallery-container').on('click', function(){
      if(!$('body').hasClass('home')) {
        hideSlider();
      }
    });

    function updateURL2(slideIndex) {
      var url = "#"+slideIndex;
      window.history.pushState({"pageTitle":"Merrick d'Arcy-Irvine"},"", url);
    }

    $('.nav-private-slide').on('click', function(){
      popupSlider(0);
      $(this).closest('#header').find('a').removeClass('active');
      $(this).addClass('active');
    });

    $('#private-index').on('click', function(){
      $(this).closest('#header').find('a').removeClass('active');
      $(this).addClass('active');
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/index.js